import * as React from 'react';
import {Glyphs} from '@techsmith/tsc-cloud-style-guide';
import Strings from '../../globals/Strings';

export default ({href}: HelpLinkProps) => {
   return (
      <a href={href} target="_blank" title={Strings.labels.help} className="help-link">
         <Glyphs.Question16x16/>
      </a>
   );
};

interface HelpLinkProps {
   href: string;
}
